import React from 'react';

import { Input } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

import { ChatMagnifierIcon } from '@core/chat/icons';

import { ISearchFieldView } from './interfaces';

import { useStyles } from './styles';

const SearchFieldView = React.forwardRef<
  HTMLInputElement | undefined,
  ISearchFieldView
>(({ sx = {}, value, onChange, onClear, placeholder }, ref) => {
  const classes = useStyles();

  return (
    <Input
      inputRef={ref}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      startAdornment={<ChatMagnifierIcon />}
      endAdornment={
        value ? <CancelIcon sx={classes.clearIcon} onClick={onClear} /> : null
      }
      fullWidth
      sx={{ ...classes.input, ...sx }}
    />
  );
});

SearchFieldView.displayName = 'SearchFieldView';

export default SearchFieldView;
